//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tagItem from "./TagItem";
import { imageLoad } from "../../utils/media";
import { showErrorMsg } from "../../utils/error";

export default {
  name: "TagGroupComponent",
  components: { tagItem },
  props: {
    image: {
      required: true,
    },
    tags: {
      // 全部选中tag
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: true,
    },
    type: {
      // tag_product 和 tag_people公用了一个控件 people 为tag people product为tag_pruduct
      type: String,
      default: "people",
    },
  },
  data() {
    return {
      searchGroupPosition: { x: 0, y: 0 },
      searchText: "",
      searchList: [],
      loading: false,
      imageLoad: false,
    };
  },
  computed: {
    /**
     * 计算图片裁切比例
     */
    ratio() {
      return 1;
    },
    /**
     * 計算裁切容器大小
     */
    containerStyle() {
      if (this.ratio > 1) {
        return {
          width: `100%`,
          height: `${(1 / this.ratio) * 100}%`,
        };
      } else {
        return {
          height: `100%`,
          width: `${this.ratio * 100}%`,
        };
      }
    },
  },
  async created() {
    try {
      console.log("image", this.image);
      this.imageLoad = false;
      // 等待图片加载完成之后才能显示tag 标签
      await imageLoad({ src: this.image.url });
      // 如果是编辑状态则将比例变更为图片比例
      // 如果图片处于编辑状态则更新到编辑之前的裁切比例
      this.imageLoad = true;
    } catch (e) {
      showErrorMsg(e);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/tag/Group.vue